import * as context from './context';
export * from './types';

const api = () => context.get();

export default api;
